import React from 'react';
import { Provider } from 'react-redux'
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import "./i18n.ts"
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom'
// - IMPORT STORE
import { GlobalStore, persistor } from './store/GlobalStore'
import { PersistGate } from 'redux-persist/integration/react';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={GlobalStore}>
    <PersistGate loading={null} persistor={persistor}>
        {/* Initialize the app */}
        <BrowserRouter>
            <App />
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
